import { actionTypes, change as reduxChange } from 'redux-form';

import { PAYMENT_METHOD_WITHOUT_PAYMENT } from '../constants';

export default store => next => action => {
	// let the action go to the reducers
	next(action);

	if (
		action.type !== actionTypes.CHANGE ||
		action.meta.field !== 'paymentMethod'
	) {
		return;
	}

	const state = store.getState();
	const formValues = state.form.bookingForm.values;

	if (formValues.paymentMethod === PAYMENT_METHOD_WITHOUT_PAYMENT && formValues.advancePaymentOnly) {
		store.dispatch(reduxChange('bookingForm', 'advancePaymentOnly', false));
	}
};


// WEBPACK FOOTER //
// ./src/store/paymentMethodMiddleware.js